import { useRef } from "react";

import { TextInput as RNTextInput, View } from "react-native";
import { TextInput, Text, useTheme } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

type Props = {
  code: string;
  setCode: (code: string) => void;
  hasError: boolean;
  maximumLength: number;
};

// Hidden TextInput with displayed boxes for OTP code
export default function CodeInput({
  code,
  setCode,
  hasError,
  maximumLength,
}: Props) {
  const boxArray = new Array(maximumLength).fill("");
  const inputRef = useRef<RNTextInput>(null);

  const tailwind = useTailwind();

  return (
    <View style={tailwind("justify-center items-center")}>
      <View style={tailwind("flex-row justify-evenly")}>
        {boxArray.map((_, index) => {
          const digit = code[index] || "•";
          const isFocused = index === code.length;
          return (
            <CodeDigit
              key={index}
              digit={digit}
              isFocused={isFocused}
              hasError={hasError}
            />
          );
        })}
      </View>
      <TextInput
        value={code}
        mode="outlined"
        textContentType="oneTimeCode"
        autoComplete="sms-otp"
        keyboardType="number-pad"
        maxLength={maximumLength}
        ref={inputRef}
        autoFocus
        onChangeText={setCode}
        style={tailwind("opacity-0 absolute")}
      />
    </View>
  );
}

type CodeDigitProps = {
  digit: string;
  isFocused: boolean;
  hasError: boolean;
};

function CodeDigit({ digit, isFocused, hasError }: CodeDigitProps) {
  const { colors } = useTheme();
  const tailwind = useTailwind();

  const borderColor = hasError
    ? colors.error
    : isFocused
    ? colors.primary
    : colors.surfaceVariant;

  return (
    <View
      style={[
        tailwind("border-2 rounded px-3 py-2 flex-1 mx-0.5"),
        { borderColor },
      ]}
    >
      <Text variant="titleLarge" style={[tailwind("text-center")]}>
        {digit}
      </Text>
    </View>
  );
}
